import get from 'lodash-es/get';
import { useFormikContext } from 'formik';
import { formatValidationMessage } from '@/common/application/utils/fieldNameFormatter';

interface UseFormikFieldProps<T> {
  id: keyof T | string;
}

export function useFormikField<T extends Record<string, unknown>>({ id }: UseFormikFieldProps<T>) {
  const { status, values, setFieldValue, setFieldTouched, handleChange, handleBlur, touched, errors } = useFormikContext<T>();

  // Use lodash get to safely access nested values and errors
  const fieldValue = get(values, id as string);
  const fieldError = get(errors, id as string);
  const fieldTouched = get(touched, id as string);

  // Format the helperText properly, applying user-friendly formatting to error messages
  const errorText = fieldTouched && fieldError ? formatValidationMessage(String(fieldError), id as string) : `\u00A0`;

  // Handle error condition: Check if the error exists for the field
  const hasError = fieldTouched && fieldError !== undefined && fieldError !== '';

  return {
    status,
    values,
    setFieldValue,
    setFieldTouched,
    handleChange,
    handleBlur,
    errorText,
    hasError,
    fieldValue
  };
}
